import React from 'react';
import styles from './style.module.css';
import hex2rgba from './hex2rgba';
export default class Score extends React.Component {
  constructor(props) {
    super(props);
    this.canvas = React.createRef();
    this.ctx = null;
    this.devicePixelRatio = null;
    this.stepsColors = ['#d12000', '#f1bc00', '#84c42b', '#3da940'];
    this.maxValue = 850;
    this.maxAngle = 260;
    this.rotation = 90;
    this.lineWidth = 20;
    this.scoreValue = 'Bad';

    // this.stepRange = this.maxValue / this.stepsColors.length;

    if (props.value < 630) {
      this.scoreNumber = 1;
      this.scoreValue = 'Bad';
    } else if (props.value < 690) {
      this.scoreNumber = 2;
      this.scoreValue = 'Fair';
    } else if (props.value < 720) {
      this.scoreNumber = 3;
      this.scoreValue = 'Good';
    } else {
      this.scoreNumber = 4;
      this.scoreValue = 'Excellent';
    }
    // this.scoreNumber = props.value / this.stepRange;
    // //console.log(this.scoreNumber)
    this.lineGap = 0;
    this.valueSize = (40 * props.width) / 200;
    this.maxValueSize = (20 * props.width) / 200;
    this.scoreValuePosition = (25 * props.width) / 200;
  }

  draw(ctx) {
    if (!ctx || !this.devicePixelRatio) return;
    const { width, fadedOpacity } = this.props;

    // change size canvas when HDPI screen
    const pixelRatio = this.devicePixelRatio;
    const wRatio = width * pixelRatio;
    this.canvas.current.width = wRatio;
    this.canvas.current.height = wRatio;

    const halfWidth = wRatio / 2;
    const pieSize = this.maxAngle / this.stepsColors.length;
    let lastval = 0;

    ctx.clearRect(halfWidth * -1, halfWidth * -1, wRatio, wRatio);
    ctx.resetTransform();

    ctx.translate(wRatio / 2, wRatio / 2);
    ctx.rotate(Math.PI * 2 * ((this.rotation + (360 - this.maxAngle - this.lineGap) / 2) / 360));

    for (let i = 0; i < this.stepsColors.length; i++) {
      // //console.log("drawing colors")
      ctx.beginPath();
      ctx.arc(0, 0, halfWidth - (this.lineWidth * pixelRatio) / 2, Math.PI * 2 * ((lastval + this.lineGap) / 360), Math.PI * 2 * ((lastval + pieSize) / 360));
      lastval += pieSize;
      if (this.scoreNumber < i + 1) ctx.strokeStyle = hex2rgba(this.stepsColors[i], fadedOpacity);
      else ctx.strokeStyle = this.stepsColors[i];
      ctx.lineWidth = this.lineWidth * pixelRatio;
      ctx.stroke();
    }
  }

  componentDidMount() {
    this.devicePixelRatio = window.devicePixelRatio;
    this.ctx = this.canvas.current.getContext('2d');

    this.draw(this.ctx);
  }

  render() {
    const { width, textStyle } = this.props;

    // this.draw(this.ctx);

    return (
      <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <div className='position-relative'>
          <canvas className={styles.rangeSvg} ref={this.canvas} style={{ width }} width={width} height={width} />
          <div
            className={styles.scoreValue}
            style={{
              bottom: this.scoreValuePosition,
              ...textStyle,
              textAlign: 'center',
            }}>
            <span className={styles.value} style={{ fontSize: this.valueSize }}>
              {this.props.value}
            </span>
          </div>
        </div>
        <div style={{ textAlign: 'center', marginTop: -10 }}>
          <h1>{this.scoreValue}</h1>
          {/* <div style={{height: 30}}>
                <img src={this.props.burea} className="img-fluid" />
              </div> */}
          {/* <h5 className="text-muted mt-3">VantageScore 3.0 <sup>TM</sup></h5> */}
        </div>
      </div>
    );
  }
}
